import { useTeamMemberNameLookup } from './useTeamMemberNameLookup';

/**
 * Resolves a customer id to a display name, sourced from HomeContext's team member list (see
 * useTeamMemberNameLookup) rather than a per-id API call. Falls back to a placeholder for ids
 * outside the business (Xero groups don't carry one) or with no match.
 */
export const useCustomerName = (customerId?: string | null): string => {
  const lookupName = useTeamMemberNameLookup();
  return lookupName(customerId);
};
